import { asyncLoad } from '@util'

const List = asyncLoad(() => import('@components/ChaoHunJie/List'))
const Introduce = asyncLoad(() => import('@components/ChaoHunJie/Introduce'))
const Form = asyncLoad(() => import('@components/ChaoHunJie/Form'))

export default [
  {
    path: 'chaohunjie',
    indexRoute: {
      component: List
    },
    childRoutes: [
      {
        path: 'introduce',
        component: Introduce
      },
      {
        path: 'form(/:id)',
        component: Form
      }
    ]
  }
]
